import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-message-success-modal',
  imports: [BaseModalComponent, MatIconModule, TranslocoDirective],
  templateUrl: './message-success-modal.component.html',
  styleUrl: './message-success-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageSuccessModalComponent {
  isOpen = input<boolean>(false);

  title = input<string>();

  message = input<string>();

  showViewSent = input<boolean>(true);

  closed = output<void>();

  viewSent = output<void>();

  protected onClose(): void {
    this.closed.emit();
  }

  protected onViewSent(): void {
    this.viewSent.emit();
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closed.emit();
    }
  }
}
